'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const UIContext = /*#__PURE__*/ createContext(null);
const useUIContext = ()=>{
    const ctx = useContext(UIContext);
    if (!ctx) {
        throw new Error("useUIContext must be used within a UIProvider");
    }
    return ctx;
};
const UIProvider = ({ children, value })=>{
    return /*#__PURE__*/ jsx(UIContext.Provider, {
        value: value,
        children: children
    });
};

export { UIContext, UIProvider, useUIContext };
